import { createFileRoute } from '@tanstack/react-router';

import { LearnPhoebePage } from '@apps/web/features/learn_phoebe';

export const Route = createFileRoute('/_app/(main)/learn-phoebe')({
    component: LearnPhoebePage,
    head: () => ({
        meta: [{ title: 'Learn Phoebe | Phoebe' }],
    }),
});
